{
  "welcome": {
    "title": "خوش آمدید، {{name}}",
    "title_noName": "Rhemn میں خوش آمدید",
    "body": "جو چیز چمکتی ہے، وہ آپ کو دکھائے گی کہ وہ کیا کرتی ہے۔ جس ترتیب سے چاہیں، جب چاہیں دیکھیں۔",
    "start": "دیکھنا شروع کریں",
    "later": "ابھی نہیں"
  },
  "card": {
    "tryIt": "آزمائیں",
    "takeALook": "ایک نظر دیکھیں",
    "pro": "Rhemn Pro کا حصہ",
    "close_aria": "بند کریں"
  },
  "pill": {
    "progress": "{{total}} میں سے {{count}} دیکھے گئے",
    "progress_short": "{{total}} میں سے {{count}}",
    "done": "ہو گیا",
    "done_aria": "دیکھنا ختم کریں",
    "complete": "سب دیکھ لیا"
  },
  "sr": {
    "started": "ایکسپلور موڈ آن ہے۔ بٹن کام کرنے سے پہلے بتاتے ہیں کہ وہ کیا کرتے ہیں۔",
    "hint": "ایکسپلور موڈ۔ پہلے بتاتا ہے کہ یہ کیا کرتا ہے۔",
    "ended": "ایکسپلور موڈ بند ہے۔"
  },
  "settings": {
    "row": "Rhemn کیسے کام کرتا ہے",
    "row_sub": "ہر حصے پر ایک مختصر نظر",
    "row_aria": "Rhemn کیسے کام کرتا ہے: ایپ کو دوبارہ دیکھیں",
    "helpCaption": "مدد"
  },
  "steps": {
    "intention": {
      "title": "آج کی نیت",
      "body": "آج کی سب سے اہم بات لکھیں، اور مکمل ہونے پر اسے نشان زد کریں۔"
    },
    "now": {
      "title": "نماز کے ساتھ آپ کا دن",
      "body": "Rhemn آپ کے دن کو ہر نماز پر تقسیم کرتا ہے۔ یہ اگلی نماز تک باقی وقت اور اس دوران کے لیے آپ کا منصوبہ دکھاتا ہے۔"
    },
    "verse": {
      "title": "آیت کی بصیرت",
      "body": "آج کی آیت کے بارے میں سوال پوچھیں، مختصر تفسیر پڑھیں، اور اسی موضوع کی آیات تلاش کریں۔"
    },
    "qibla": {
      "title": "قبلہ",
      "body_chrome": "آپ کے مقام سے خانہ کعبہ کی سمت، شمال سے زاویے کی صورت میں۔",
      "body_ios": "آپ کے مقام سے خانہ کعبہ کی طرف اشارہ کرتا ہے۔ لائیو کمپاس آن کریں، اور یہ آپ کے مڑنے کے ساتھ ساتھ گھومتا ہے۔"
    },
    "prayer": {
      "title": "نماز کے اوقات",
      "body_chrome": "آپ کے مقام کے لیے آج کی پانچوں نمازوں کے اوقات۔ وہ طریقۂ حساب منتخب کریں جو آپ کی مسجد اپناتی ہے۔",
      "body_ios": "آپ کی اگلی نماز ایک نظر میں۔ اسے کھول کر پانچوں اوقات اور ہر نماز کی یاد دہانی دیکھیں۔"
    },
    "tasks": {
      "title": "کام",
      "body": "اپنے کام فہرستوں میں رکھیں، اور ہر ایک کو نمازوں کے درمیان جگہ دیں۔"
    },
    "notes": {
      "title": "نوٹس",
      "body_chrome": "لکھیں، یا بس بولیں۔ Rhemn آپ کے صوتی نوٹس اور میٹنگز کو تحریر میں بدلتا ہے، پھر ان کا خلاصہ بناتا ہے۔",
      "body_ios": "لکھیں، یا بس بولیں۔ Rhemn آپ کی بات کو صاف، خلاصہ شدہ نوٹس میں بدل دیتا ہے۔"
    },
    "profile": {
      "title_chrome": "آپ کا پروفائل",
      "body_chrome": "آپ کا اکاؤنٹ اور رازداری کی ترتیبات۔ Rhemn کو دوبارہ دیکھنے کے لیے یہاں واپس آئیں۔",
      "title_ios": "مزید",
      "body_ios": "محفوظ آیات، قبلہ، اور آپ کے اکاؤنٹ کی ترتیبات۔ آپ یہاں سے Rhemn کو دوبارہ دیکھ سکتے ہیں۔"
    }
  }
}
